import { createApiDescription } from "../../helperFunctions";

export const returnsInfo = {
    upload: createApiDescription(
        "This API can be called to Upload the tax returns and recognize immediately.",
        [
            "Users can upload a single document as well as multiple documents.",
            "Upload API supports both Base64 file format and File URL format but while sending the request either one of the file formats should be provided."
        ]
    ),
    uploadedReturns: createApiDescription(
        "This API can be called to get the list of all returns uploaded via API by the logged in user.",
        ["This API will only show returns uploaded via the API by the current logged in user."]
    ),
    append: createApiDescription(
        "This API can be called to append the tax returns with already uploaded unrecognized returns.",
        [
            "User can append a single document as well as multiple documents with file URLs.",
            "Append API supports both Base64 file format and File URL format but while sending the request either one of the file formats should be provided.",
            "User should append the tax returns of same tax software as per previously uploaded tax return type.",
            "User needs to call recognizer API after all tax returns are appended.",
            "Append API doesn't support ProSystem tax software."
        ]
    ),
    fetchReturnDetails: createApiDescription(
        "API to fetch return details based on taxReturnId.",
        []
    ),
    partialUpload: createApiDescription(
        "This API can be called to partially upload the returns and allow users to append returns later using the Append API.",
        [
            "Users can upload single document as well as multiple documents with file URLs.",
            "Partial Upload API supports both Base64 file format and File URL format but while sending the request either one of the file formats should be provided.",
            "Partial Upload API doesn't support ProSystem tax software."
        ]
    ),
    recognize: createApiDescription(
        "This API can be called to Start the Recognition of the given un-recognized return.",
        [
            "Recognize API can be configured with CallBack mechanism by providing callbackUri in the request body and callback-api-key in the request header.",
            "After the Recognition job is completed, the response will be posted to the given callback endpoint.",
            "Recognition API will fail if tax return is already recognized."
        ]
    ),
    setAccess: createApiDescription(
        "This API is used to set access for given return.",
        ["User IDs can be found by calling user management GET APIs."]
    ),
    unRecognizedReturns: createApiDescription(
        "This API can be called to get the list of all un-recognized returns.",
        ["This API will only return a list of returns that have not gone through the SafeSend recognition engine."]
    )
};
